import '../../styles/views/wishlist.scss';
import productViewModule from '../_partials/product-view/productView.module.js';
import WishlistPageCtrl from './controllers/wishlistPageController.js';
import WishlistPageService from '../_partials/wishlist/services/wishlistService.js';
import tabsModule from '../_common/tabs/tabs.module.js';
var deps = [tabsModule, productViewModule];
var moduleName = 'wishlistPage';
angular.module(moduleName, deps).service('wishlistService', WishlistPageService).controller('WishlistPageCtrl', WishlistPageCtrl);
export default moduleName;